import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, SalesOrderDTO } from 'core/api';
import { Command } from 'pos/common';
import * as SalesOrderStore from './SalesOrderStore';


declare global {
	interface CommandType {
		prepareSalesOrderAgain: (order: SalesOrderDTO) => Promise<Result>,
		prepareSalesOrder: (order: SalesOrderDTO) => Promise<Result>
	}
}


Command.register('prepareSalesOrderAgain', Preconditions.ensure(Permission.Ticket_PrepareTicketAgain), async (order: SalesOrderDTO): Promise<Result> => {
	return prepareTicketsAgain([order.TicketId]);
});


async function prepareTicketsAgain(ticketIds: number[]): Promise<Result> {
	await SalesOrderStore.prepareAgain(ticketIds);
	return Result.ok();
}


Command.register('prepareSalesOrder', Preconditions.ensure(Permission.Ticket_PrepareTicket), async (order: SalesOrderDTO) => {
	return prepareTickets([order.TicketId]);
});

async function prepareTickets(ticketIds: number[]): Promise<Result> {
	await SalesOrderStore.prepare(ticketIds);
	return Result.ok();
}

